export type TApiAps = ReturnType<typeof createApiAps>;

export const createApiAps = () => {
    const getDataGovernanceEnabledDatabases =
        async () // userSelectedDatabases: number[],
        : Promise<number[]> => {
            return await Promise.resolve([]);
        };
    // This will be actually implemented in the future
    // TODO: implement the infra to support aps requests
    return { getDataGovernanceEnabledDatabases };
};
